'use strict';

module.exports = require('./_and-or')(require('es5-ext/function/identity'));
